import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["statement", "list", "item", "hidden", "template"]
  }

  connect() {
    // Feature specs click Remove as soon as the page is visited. The
    // button is in the HTML before this pack runs, so a click in that
    // gap does nothing and the form saves the original declarations.
    this.element.dataset.giftAidDeclarationsEditorConnected = "true"
    this.syncHiddenField()
  }

  addDeclaration() {
    this.listTarget.appendChild(this.templateTarget.content.cloneNode(true))
    this.syncHiddenField()

    const items = this.itemTargets
    const input = items[items.length - 1]?.querySelector("input")

    if (input) {
      input.focus()
    }
  }

  removeDeclaration(event) {
    const item = event.currentTarget.closest(
      "[data-gift-aid-declarations-editor-target='item']"
    )

    item?.remove()
    this.syncHiddenField()
  }

  syncHiddenField() {
    const declarations = this.itemTargets.map(
      (item) => item.querySelector("input").value
    )

    this.hiddenTarget.value = JSON.stringify({
      statement: this.statementTarget.value,
      declarations
    })
  }
}
